import { render, staticRenderFns } from "@/style-guide/partials/convocation/convocation.pug?vue&type=template&id=52ed45ca&lang=pug&external"
import script from "./convocation.vue?vue&type=script&lang=ts"
export * from "./convocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports